module.exports = __webpack_public_path__ + "static/media/raja.2374abb9.jpg";